<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="tourism-search__item col-lg-3">
            <div class="form-group">
              <label class="form-title">Країни подорожі</label>
              <multiselect
                :class="['form-control  tourism-search-select',  {invalid: ((!$v.country.required) && submitCheck)}]"
                v-model="country"
                :options="countries"
                placeholder="Наприклад США"
                :allow-empty="false"
                label="name"
                :loading="true"
              >
                <template slot="option" slot-scope="{ option }">
                                    <span v-if="typeof option.label === 'string' && typeof option.name !== 'undefined'">
                                        <strong>{{ option.name }}: </strong>
                                        <span>{{ option.label }}</span>
                                    </span>
                  <span v-else-if="option.label && typeof option.label !== 'string'">
                                        <strong>{{ option.name }}</strong>
                                    </span>
                  <span v-else-if="!option.label">
                                        {{ option.name }}
                                    </span>
                  <span v-else>
                                        {{ option.label }}
                                    </span>
                </template>
              </multiselect>
              <div>
                                <span v-for="(item, index) in popularFourCountries">
                                    <a href="#" @click.prevent="choseCountry(item)" class="link" v-text="item.name"></a>
                                    <span v-if="index !== (popularFourCountries.length - 1)">, </span>
                                </span>
              </div>
              <small class="error" v-if="!$v.country.required && submitCheck">
                {{ 'Вкажіть країну' }}
              </small>
            </div>
          </div>
          <BirthDatesInput
            class="tourism-search__item col-lg-3 col-sm-4"
            v-model="birthDates"
            :validator="$v"
          />
          <div class="col-lg-3 col-sm-4">
            <div class="form-group datapicker-mask" ref="start_date">
              <div>
                <label class="form-title">Коли виїжджаєте</label>
                <date-picker
                  name="start_date"
                  v-model="start_date"
                  :config="optionsDate"
                  :class="['date-input__dp']"
                  placeholder="Від’їзд">
                  <template #input>
                    <input
                      type="text"
                      class="form-control date-input__dp"
                      placeholder="Від’їзд"
                    >
                  </template>
                </date-picker>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-4">
            <div class="form-group" v-if="multiVisa">
              <label class="form-title">Період дії</label>
              <multiselect
                :class="['form-control  tourism-search-select',  {invalid: ((!$v.periodOption.required) && submitCheck)}]"
                v-model="periodOption"
                :options="periods"
                placeholder="Наприклад 30"
                :allow-empty="false"
                :taggable="true"
                @tag="addPeriodTag"
              >
              </multiselect>
              <small class="error" v-if="!$v.periodOption.required && submitCheck">
                {{ 'Вкажіть період' }}
              </small>
            </div>
            <div class="form-group" v-else>
              <label class="form-title">Період дії</label>
              <input class="form-control" v-model="periodOption" v-on:keypress="LetterNumMask($event)"
                     type="number" placeholder="Кількість днів">
              <!--                            <small class="error" v-if="(!$v.periodOption.required || !$v.periodOption.Validate) && submitCheck">Мінімум 30 днів</small>-->
            </div>
            <div class="form-group form-check mt-0">
              <input class="form-check-input" type="checkbox" v-model="multiVisa" id="multiVisa">
              <label class="form-check-label font-weight-normal" for="multiVisa">
                Мультивіза
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 submit">
        <button type="button" class="btn btn-blue mt-auto tourism-tab-content__submit w-100 mb-5"
                @click.prevent="setSearchParams">Показати результати
        </button>
      </div>
    </div>
  </div>
</template>
<style>

.selectors.tourism-select .results .result-item .result-item__logo img {
  max-width: 80%;
  max-height: 35px;
  height: auto;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.tourism-tab-content__submit {
  min-height: 42px;
}

</style>
<script>
import axios from "axios";
import Multiselect from 'vue-multiselect'
import {maxLength, required} from 'vuelidate/lib/validators';
import BirthDatesInput from "@/views/tourism/components/BirthDatesInput.vue";

export default {
  components: {BirthDatesInput, Multiselect},
  // props: [
  //     'dataCountry',
  //     'dataStart',
  //     'dataEnd',
  //     'dataPeriodOption',
  //     'dataMultiVisa',
  //     'dataHumans',
  //     'dataFilters',
  //     'dataBirthDates'
  // ],
  data: function () {
    return {
      periods: [
        365,
        350,
        270,
        180,
        90,
        60,
        30,
        15,
        10,
        7,
      ],
      birthDates: [],
      maxTourists: 5,
      periodOption: 7,
      submitCheck: false,
      multiVisa: false,
      // Дефолт — завтра: день у день оформлюють не всі СК; сьогодні
      // лишається доступним у календарі (minDate нижче)
      start_date: moment().add(1, 'day').format('DD.MM.YYYY'),
      countries: [],
      country: null,
      optionsDate: {
        format: 'DD.MM.YYYY',
        useCurrent: false,
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        locale: 'uk',
        icons: {
          previous: 'icon arrow-point-to-left',
          next: 'icon arrow-point-to-right',
        },
      },
    };
  },
  validations: {
    country: {
      required
    },
    periodOption: {
      required,
    },
    birthDates: {
      required,
      maxLength: maxLength(5)
    },
  },
  mounted: function () {
    this.fetchCountries();
    if (this.checkResultTourismRoute()) {
      const searchInfo = this.$store.getters.GET_SEARH_TOURISM_PARAMS;
      this.birthDates = searchInfo.birthDates
      this.multiVisa = searchInfo.multiVisa
      this.country = searchInfo.country
      
      // Збережену дату з минулого скидаємо на дефолт (завтра);
      // обраний вручну сьогоднішній день зберігаємо
      let savedDate = moment(searchInfo.date, 'DD.MM.YYYY');

      if (savedDate.isValid() && savedDate.isBefore(moment().startOf('day'))) {
        this.start_date = moment().add(1, 'day').format('DD.MM.YYYY');
      } else {
        this.start_date = searchInfo.date;
      }

      this.$nextTick(() => {
        this.periodOption = searchInfo.days
      })
    }
  },
  computed: {
    popularFourCountries: function () {
      let popular = ['Весь світ', 'Європа'];

      return this.countries.filter((country) => {
        return popular.includes(country.name);
      });
    },
  },
  watch: {
    multiVisa() {
      this.periodOption = null;
    },
  },
  methods: {
    addPeriodTag(event) {
      this.periods.push(event)
    },
    checkResultTourismRoute() {
      return this.$router.currentRoute.name === 'tourismResult';
    },
    choseCountry(value) {
      this.country = value;
    },
    setSearchParams() {
      this.submitCheck = true;

      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      const params = {
        date: this.start_date,
        days: parseInt(this.periodOption),
        country: this.country,
        multiVisa: this.multiVisa,
        birthDates: this.birthDates,
        //TODO tourists deprecated
        tourists: this.birthDates.length,
      };

      this.$store.commit('SET_SEARCH_TOURISM_PARAMS', params);
      if (this.checkResultTourismRoute()) {
        this.$parent.showTourismSearchForm = !this.$parent.showTourismSearchForm
        return
      } else {
        this.$router.push({name: `tourismResult`});
      }
    },
    fetchCountries() {
      axios.get('/api/countries/list')
        .then(({data}) => {
          this.countries = data.data;
        });

    },
    LetterNumMask(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z0-9 ]+$/.test(char)) {
        this.LetterMaskError = false;
        return true;
      } // Match with regex
      else {
        this.LetterMaskError = true;
        e.preventDefault();
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
